import * as React from 'react';
import styled from 'styled-components';
import * as Colors from '../../constants/colors';
import { Card, Button, Row, Col, LeftAvatarRightTitle } from './index';
import { H4 } from '../common';

const CardColumn = styled(Col)`
  padding: 1em;
`;

const StyledCardFirstColumn = styled(CardColumn)`
  background: ${(props: Col & CartLineItemProps) => props.backgroundColor};

  > h3 {
    color: #555;
    font-weight: 600;
    margin-bottom: 0.4em;
  }
`;

const CardSecondColumn = styled(CardColumn)`
  > h3 {
    color: ${Colors.textDarkColor};
    font-weight: 600;
  }
`;

const CardLastColumn = styled(CardColumn)`
  text-align: center;
`;

const StyledCard = styled(Card)`
  margin-bottom: 1em;
  border-color: #ccc;
`;

/**
 * This wrapper is to satisfy tsc.
 */
const CardFirstColumn: React.SFC<any> = props => {
  return <StyledCardFirstColumn {...props} />;
};

interface CartLineItemProps {
  backgroundColor: string;
  title: string;
  subtitle: string;
  subSubtitle: string;
  imgSrc: string;
  bodyText: string;
  buttonText: string;
  labelTitle: string;
  subBodyText: string;
  onClickButton: Function;
}

const StyledLabelTitle = styled(H4)`
  margin-bottom: 1em;
`;

export const CartLineItem: React.SFC<CartLineItemProps> = props => (
  <StyledCard bodyStyle={{ padding: 0 }}>
    <Row type="flex" align="middle" justify="center">
      <CardFirstColumn backgroundColor={props.backgroundColor} span={24} lg={5}>
        <h3>{props.title}</h3>
        <LeftAvatarRightTitle title={props.subtitle} imgSrc={props.imgSrc} />
      </CardFirstColumn>
      <CardSecondColumn span={24} lg={4}>
        <h3>{props.subSubtitle}</h3>
      </CardSecondColumn>
      <CardColumn span={24} lg={5}>
        <h3>{props.bodyText}</h3>
      </CardColumn>
      <CardColumn span={24} lg={5}>
        <h3>{props.subBodyText}</h3>
      </CardColumn>
      <CardLastColumn span={24} lg={5}>
        <StyledLabelTitle>{props.labelTitle}</StyledLabelTitle>
        <Button size="large" onClick={e => props.onClickButton(e)}>
          {props.buttonText}
        </Button>
      </CardLastColumn>
    </Row>
  </StyledCard>
);



// WEBPACK FOOTER //
// ./app/components/antd/CartLineItem.tsx